import { call } from './utils';

//****BIKES CRUD

//bike creation
export const createBike = async (data, accessToken) =>
  await call({
    url: '/api/bike/create',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//bike update
export const updateBike = async (data, accessToken) =>
  await call({
    url: '/api/bike/update',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//bike removeBike
export const removeBike = async (data, accessToken) =>
  await call({
    url: '/api/bike/remove',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//bike findAllBikes
export const findAllBikes = async (data, accessToken) =>
  await call({
    url: '/api/bike/find/all',
    data: { data },
    token: accessToken
  });
//bike findBikeById
export const findBikeById = async (data, accessToken) =>
  await call({
    url: '/api/bike/find/by/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//bike getAllBikesByStationId
export const getAllBikesByStationId = async (data, accessToken) =>
  await call({
    url: '/api/bike/find/all/by/station/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//bike removeBikeByStationId
export const removeBikeByStationId = async (data, accessToken) =>
  await call({
    url: '/api/bike/find/all/by/station/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
